export enum TaskRole {
    OWNER = 'OWNER',
    VIEWER = 'VIEWER',
}

export class TaskRoleHelper {
    static getTaskRoleIcon(role: TaskRole): string {
        switch (role) {
            case TaskRole.OWNER:
                return 'assignment_ind';
            case TaskRole.VIEWER:
                return 'remove_red_eye';
            default:
                return '';
        }
    }
}
